import screenshotFiles from "./screenshots/index";

export default screenshotFiles;

// let samples = [];

// const useScreenshotFiles = true; //userAgent.isScreenshotApp();

// if (useScreenshotFiles) {
//   recentFiles = screenshotFiles;

// //#!if ENV !== "production"
// samples.push({
//   name: "Murder on the Orient Express",
//   icon: "train",
//   fullPath: "murderV3Data"
// });
// 
// samples.push({
//   name: "Product Roadmap",
//   icon: "star",
//   fullPath: "sampleV3Data"
// });
// //#!endif

// export default samples;
